import * as React from "react";
import styled from "styled-components";
import * as h from "../../_themes/helpers";

interface IProps {
  value: number;
}

export const Value = ({ value }: IProps) => (
  <Wrapper>{value.toFixed(0)}</Wrapper>
);

export const Wrapper = styled.div`
  height: 2.8em;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 0.6em;
  font-weight: 700;
  padding: 0.5em 0 0;
  color: ${h.getColor("sliderValue", "slider.value")};
`;
